import { Component } from '@angular/core';
import { CourseContentDisplayComponent } from '../course-content-display/course-content-display.component';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-content-display-link',
  templateUrl: './course-content-display-link.component.html',
  styleUrls: ['./course-content-display-link.component.scss']
})
export class CourseContentDisplayLinkComponent extends CourseContentDisplayComponent {
  constructor(
    ucdService: UserCourseDataService
  ) {
    super(ucdService);
  }

  ngOnInit() {
  }
}
